export const resume = (text = '', length = 100) => {
  if (text && text.length > length) {
    return `${ text.substring(0, length - 3) }...`;
  }

  return text;
};
